export default "__VITE_ASSET__DRrKEW9J__"